<script setup lang="ts">
import { reactive } from "vue";
import { useApplicationStore } from "../stores/application";
import DefenceLineQuestion from "./DefenceLineQuestion.vue";

const application = useApplicationStore();

const questions = reactive(application.defenceQuestions);

</script>
<template>
    <div class="card-body-new">
        <h4 class="line-height-intro mt-3">
            Please read and answer the following questions before continuing with your
            application:
        </h4>
        <p>
            They have no right or wrong answers and are to help you stop and reflect,
            before making decisions that could be irreversible.
            <br><br>
            Using your responses, we will provide warnings to help you confirm the decisions you've made.
        </p>
    </div>
    <div class="mt-4">
        <div
            v-for="(question, index) in questions"
            :key="index"
        >
            <DefenceLineQuestion
                :question="question"
                :question-row="true"
                @value-change="(value) => question.value = value"
            />
            <hr
                v-if="index !== questions.length - 1"
                data-testid="separatorLine"
                class="mb-4"
            >
        </div>
    </div>
</template>
